// Kinio Node〔終端機〕新視窗（SPEC #node-ttl-vms-terminal）：/terminal/{home}/{device}，只有終端機、沒有側欄；權限同設備頁（device.read、Kinio Node 本體）。
import { useTranslation } from 'react-i18next';
import { Link, useParams } from 'react-router-dom';
import { useDevices } from '../../lib/useDevices';
import { can } from '../../lib/devices';
import { isKinioNode } from './consoleRelay';
import { NodeTerminal } from './NodeTerminal';
import { deviceHref } from './DeviceDetailPage';

export function TerminalPage() {
  const { t } = useTranslation();
  const { homeId = '', aid = '' } = useParams();
  const { tree, loading } = useDevices();
  const dev = tree.find((d) => d.homeId === homeId && d.aid === aid);
  if (!dev || dev.parentAid || !isKinioNode(dev.model) || !can(dev, 'device.read')) {
    return (
      <section style={{ padding: 16 }}>
        <p className="muted">{loading ? t('common.loading') : t('ddev.not_found')}</p>
        {!loading && <Link to={deviceHref({ homeId, aid })}>{t('ddev.back')}</Link>}
      </section>
    );
  }
  return <NodeTerminal dev={dev} standalone />;
}
